import { render } from "./GSAxb.vue?vue&type=template&id=7d05baa4&scoped=true"
import script from "./GSAxb.vue?vue&type=script&lang=js"
export * from "./GSAxb.vue?vue&type=script&lang=js"

import "./GSAxb.vue?vue&type=style&index=0&id=7d05baa4&scoped=true&lang=css"
import "./GSAxb.vue?vue&type=style&index=1&id=7d05baa4&lang=css"
script.render = render
script.__scopeId = "data-v-7d05baa4"

export default script